/**
 * Ostrý / Test na přihlašovací obrazovce mobilní aplikace.
 *
 * Aplikace je jedna a mluví se serverem, který je zvolený tady (stejný
 * přepínač prostředí jako v POSu). Přepnutí zapomene přihlášení a aplikaci
 * načte znovu proti druhému serveru — test poznáš podle štítku TEST.
 * Na webu se nevykreslí: tam rozhoduje adresa v prohlížeči.
 */
export default function PrepinacServeru() {
    const aplikace = window.__FL_APLIKACE;
    if (!aplikace?.prepnoutServer) return null;

    const volby = [
        { klic: 'ostry', popis: 'Ostrý' },
        { klic: 'test', popis: 'Test' },
    ];
    const aktivni = aplikace.serverKlic;

    return (
        <div style={{ display: 'flex', justifyContent: 'center', marginTop: 20 }}>
            <div role="radiogroup" aria-label="Server" style={{
                display: 'flex', gap: 2, padding: 3, borderRadius: 10,
                background: 'var(--surface-elevated)', border: '1px solid var(--border-subtle)',
            }}>
                {volby.map(({ klic, popis }) => {
                    const on = aktivni === klic;
                    return (
                        <button key={klic} type="button" role="radio" aria-checked={on}
                            onClick={() => { if (!on) aplikace.prepnoutServer(klic); }}
                            style={{
                                minWidth: 88, height: 36, borderRadius: 8, border: 'none',
                                fontSize: 14, fontWeight: 700, cursor: on ? 'default' : 'pointer',
                                background: on ? (klic === 'test' ? 'rgba(239,68,68,0.18)' : 'rgba(245,158,11,0.18)') : 'transparent',
                                color: on ? (klic === 'test' ? '#F87171' : '#FBBF24') : 'var(--text-muted)',
                            }}>
                            {popis}
                        </button>
                    );
                })}
            </div>
        </div>
    );
}
